import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {PayeeTaxDocument} from "@app/payroll/payroll";

@Injectable()
export class PayeeDocumentService {

  constructor(private http: HttpClient) { }

  private payeeDocumentsSummary = `/payroll/payees/tax-forms?payeeId=`;
  private payeeDocumentsSearch = `/payroll/payees/tax-forms?`;

  getPayeeDocumentsSummary(payeeId: number): Observable<any> {
    return this.http.get<PayeeTaxDocument>(`${this.payeeDocumentsSummary}${payeeId}`);
  }
  searchPayeeDocuments(searchOption: any) {
    let query = "";
    if (searchOption.year) {
      query += "year=" + searchOption.year;
    }
    if (searchOption.documentType) {
      if (query != "") {
        query += "&";
      }
      query += "payeeFormType=" + searchOption.documentType;
    }
    if (searchOption.checkDate) {
      if (query != "") {
        query += "&";
      }
      query += "checkDate=" + searchOption.checkDate;
    }

    if (searchOption.payeeId) {
      if (query != "") {
        query += "&";
      }
      query += "payeeId=" + searchOption.payeeId;
    }

    let url = this.payeeDocumentsSearch + query;
    return this.http.get<any>(url);
  }
}
